import { useTranslation } from 'react-i18next';

const CTASection = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="rounded-3xl overflow-hidden shadow-xl">
          {/* Background Image */}
          <div className="relative h-80">
            <img
              src="https://public.readdy.ai/ai/img_res/68c6e7d4dad25b3cc0bd1abad9deb2f3.jpg"
              alt="Smart Greenhouse"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
          </div>

          {/* Content */}
          <div className="bg-white py-16 px-8 text-center">
            <h2 className="font-almarai text-3xl md:text-4xl text-gray-900 mb-2">
              <span className="font-light text-gray-600">{t('cta.question1')}</span>
            </h2>
            <h2 className="font-almarai text-3xl md:text-4xl text-gray-900 mb-2">
              <span className="font-bold italic">{t('cta.question2')}</span>
            </h2>
            <h2 className="font-almarai text-3xl md:text-4xl text-gray-900 mb-12">
              <span className="font-light text-gray-600">{t('cta.question3')}</span>
            </h2>

            <button
              onClick={scrollToContact}
              className="bg-black text-white px-12 py-5 rounded-full font-tajawal text-lg hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-3 shadow-lg"
            >
              {t('cta.button')}
              <i className={`ri-arrow-${isRTL ? 'left' : 'right'}-line text-xl`}></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;